import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { MessageCircle, Menu, X } from 'lucide-react';
import './Header.css';

const Header = ({ activeSection, settings }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const whatsappUrl = settings.whatsapp_url || 'https://wa.me/56949455611';
  const logoHeader = settings.logo_header || '';
  const logoMobile = settings.logo_header_mobile || '';

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      setMobileMenuOpen(false);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-container desktop-tablet-logo">
          <img
            src={logoHeader}
            alt="Centro Terapéutico Crecer Juntos"
            className="header-logo"
            onClick={() => scrollToSection('inicio')}
          />
        </div>

        <div className="mobile-fixed-header">
          <img
            src={logoMobile}
            alt="Centro Terapéutico Crecer Juntos"
            className="mobile-fixed-logo"
            onClick={() => scrollToSection('inicio')}
          />
          <div className="mobile-fixed-actions">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-fixed-whatsapp"
              aria-label="Chatear por WhatsApp"
            >
              <MessageCircle size={22} />
            </a>
            <button
              className="mobile-fixed-menu-btn"
              onClick={toggleMobileMenu}
              aria-label="Menú"
            >
              {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        <nav className="nav-menu">
          <button
            className={`nav-link ${activeSection === 'inicio' ? 'active' : ''}`}
            onClick={() => scrollToSection('inicio')}
          >
            Inicio
          </button>
          <button
            className={`nav-link ${activeSection === 'servicios' ? 'active' : ''}`}
            onClick={() => scrollToSection('servicios')}
          >
            Servicios
          </button>
          <button
            className={`nav-link ${activeSection === 'equipo' ? 'active' : ''}`}
            onClick={() => scrollToSection('equipo')}
          >
            Equipo
          </button>
          <button
            className={`nav-link ${activeSection === 'salas' ? 'active' : ''}`}
            onClick={() => scrollToSection('salas')}
          >
            Nuestras Salas
          </button>
          <button
            className={`nav-link ${activeSection === 'contacto' ? 'active' : ''}`}
            onClick={() => scrollToSection('contacto')}
          >
            Contacto
          </button>
        </nav>

        <div className="header-actions">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
            aria-label="Chatear por WhatsApp"
          >
            <MessageCircle size={20} />
          </a>
          <Button
            className="cta-button"
            onClick={() => scrollToSection('contacto')}
          >
            Agendar Cita
          </Button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-dropdown-menu">
          <button
            className={`mobile-menu-item ${activeSection === 'inicio' ? 'active' : ''}`}
            onClick={() => scrollToSection('inicio')}
          >
            Inicio
          </button>
          <button
            className={`mobile-menu-item ${activeSection === 'servicios' ? 'active' : ''}`}
            onClick={() => scrollToSection('servicios')}
          >
            Servicios
          </button>
          <button
            className={`mobile-menu-item ${activeSection === 'equipo' ? 'active' : ''}`}
            onClick={() => scrollToSection('equipo')}
          >
            Equipo
          </button>
          <button
            className={`mobile-menu-item ${activeSection === 'salas' ? 'active' : ''}`}
            onClick={() => scrollToSection('salas')}
          >
            Nuestras Salas
          </button>
          <button
            className={`mobile-menu-item ${activeSection === 'contacto' ? 'active' : ''}`}
            onClick={() => scrollToSection('contacto')}
          >
            Contacto
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
